import { Component, Input, OnInit } from '@angular/core';
import { ItemBase } from '@src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { EComWebStorage } from '@src/app/ecom-services/ecom-webstorage.services';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EcomItemDetailsPopupComponent } from '../ecom-item-details-popup/ecom-item-details-popup.component';

@Component({
  selector: 'app-ecom-item-upsell-popup',
  templateUrl: './ecom-item-upsell-popup.component.html',
  styleUrls: ['./ecom-item-upsell-popup.component.scss'],
  providers: [BsModalRef]
})
export class EcomItemUpsellPopupComponent implements OnInit {
  @Input() upSellItems?: any[] = [];

  @Input() onClose?: () => void;
  bsModalRef1: BsModalRef;
  constructor(
    private webstorage: EComWebStorage,
    private modalService: BsModalService) { }

  ngOnInit() {
    console.log(this.upSellItems);
  }

  hideModal() {
    if (this.onClose) this.onClose();
  }

  openDetailPopup(item) {
    const modalOptions = {
      class: 'detail-modal col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12',
      initialState: {
        onClose: this.hideModal.bind(this),
        item_pkid: item.item_pkid,
        iscvsd_pkid: item.ooip_iscvsd_pkid,
        category_pkid: item.ooic_pkid
      },
      backdrop: true,
      ignoreBackdropClick: true
    };
    this.bsModalRef1 = this.modalService.show(EcomItemDetailsPopupComponent, modalOptions);

    // const modalElement = document.querySelector('.detail-modal') as any;
    // if (modalElement) {
    //   modalElement.style.zIndex = '1040';
    // }
    // const overlay = document.getElementById('myOverlay');
    // overlay.classList.toggle('active'); 
  }

}
